import { render, staticRenderFns } from "./standardized-contract.vue?vue&type=template&id=572e33a4&"
import script from "./standardized-contract.vue?vue&type=script&lang=js&"
export * from "./standardized-contract.vue?vue&type=script&lang=js&"
import style0 from "./standardized-contract.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./locale/locale.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fapp%2Fsrc%2Fcomponents%2Fpages%2Fhome%2Fleuco-contract-view%2Fstandardized-contract%2Fstandardized-contract.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports